import React, { useState, useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import callAPI from "../../../../../../api/apiCaller";
import { Context } from "../../../../../../Store";
import {
  MentorsContainerOuter,
  MentorsHead,
  BackButton,
  ButtonText,
  MentorsBottom,
  MentorsHeading,
  SearchBoxFilterContainer,
  SearchParticipantsWrapper,
  FilterOption,
  FilterText,
  FilterOptions,
  FilterBy,
  FilterHeadText,
  FilterLabel,
  FilterLabelText,
  FilterClear,
  FilterButtons,
  ResetButton,
  DateInputs,
  ApplyButton,
  Select,
  Option,
  TableContainer,
  MentorDescription,
  NameContainer,
  AvatarInfo,
  Avatar,
  JoinAs,
  Cancel,
  ViewApplication,
  MentorsInfo,
  MeetingsInfo,
  ExportDeleteBtnContainer,
} from "./styles";
import { Info } from "../ActiveParticipants/styles";
import {
  AngleSpan,
  CurrentPage,
  NextButton,
  PaginationButtons,
  PaginationSpan,
  PreviousButton,
  ResultsLabel,
  ResultsSelect,
  TableActions,
  TablePagination,
} from "../../../../../../common/Table/styles";
import { Invited, Pending } from "../ProgramDashboard/styles";
import Icon from "../../../../../../common/Icon";
import TextInput from "../../../../../../common/TextInput";
import EnhancedDateRangePicker from "../../../../../../common/DatePicker";
import Table from "../../../../../../common/Table";
import Checkbox from "../../../../../../common/Checkbox";
import { formatDateForMeetings } from "../../../../../../common/utils";
import ApplicationModal from "../modals/ApplicationModal";
import { ExportCSV } from "../../../../../../common/utils";

const Applicants = ({
  setSwitchToParticipants,
  joinAs,
  setSwitchToParticipantOneOnOne,
}) => {
  const params = useParams();
  const { dispatch } = useContext(Context);
  const [applications, setApplications] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  // const [checkboxStates, setCheckboxStates] = useState({});
  // const [actionButtons, setActionButtons] = useState(null);
  const [filterOptions, setFilterOptions] = useState(false);
  const [searchParticipant, setSearchParticipant] = useState("");
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [hourRangeTo, setHourRangeTo] = useState(null);
  const [hourRangeFrom, setHourRangeFrom] = useState(null);
  const [participantLength, setParticipantLength] = useState(0);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [applicationModal, setApplicationModal] = useState(null);
  const [isCancellingInvite, setIsCancellingInvite] = React.useState({});
  const [isOpenApplicationModal, setIsOpenApplicationModal] = useState(false);
  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const formatDateTime = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const getApplicantsParticipantOpenNetworking = () => {
    setLoading(true);

    const data = {
      programId: params.selectedProgram,
      page: page,
      limit: pageSize,
      status: status?.trim() === "" ? null : status,
      search: searchParticipant?.trim() === "" ? null : searchParticipant,
    };

    callAPI(dispatch, "getApplicationOpenNetworkingProgram", data)
      .then((res) => {
        if (res) {
          setApplications(res.data);
          setCount(res.total);
          setParticipantLength(res.total);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getApplicantsParticipantOpenNetworking();
    if (!isOpenApplicationModal) setApplicationModal(null);
  }, [
    searchParticipant,
    pageSize,
    page,
    isCancellingInvite,
    isOpenApplicationModal,
  ]);

  // const resetFilters = () => {
  //   setDateRange({ from: null, to: null });
  //   setHourRangeTo(null);
  //   setHourRangeFrom(null);
  //   setStatus("active");

  //   getApplicantsParticipantOpenNetworking();
  // };

  //
  const [resetFilter, setResetFilter] = useState(false);

  const resetFilters = () => {
    setDateRange({ from: null, to: null });
    setHourRangeTo(null);
    setHourRangeFrom(null);
    setStatus("");

    if (
      dateRange?.from ||
      dateRange?.to ||
      hourRangeFrom ||
      hourRangeTo ||
      status
    ) {
      setResetFilter(true);
    }
  };

  // Watch for changes in filters and trigger API call
  useEffect(() => {
    if (
      dateRange?.from === null &&
      dateRange?.to === null &&
      hourRangeFrom === null &&
      hourRangeTo === null &&
      status === "" &&
      resetFilter
    ) {
      setResetFilter(false);
      getApplicantsParticipantOpenNetworking();
    }
  }, [dateRange, hourRangeFrom, hourRangeTo, status]);

  const applyFilters = () => {
    getApplicantsParticipantOpenNetworking();
  };
  //

  function cancelInvite(email) {
    if (isCancellingInvite[email]) {
      return;
    }
    let newCancelState = { ...isCancellingInvite, [email]: "loading" };
    setIsCancellingInvite(newCancelState);
    callAPI(dispatch, "cancelInvite", { id: email }).then();
  }

  const rowsWithNameAndDate = applications?.map((app) => ({
    ...app,
    name: `${app.firstName} ${app.lastName}`,
    dateApplied:
      app.applicationStatus === "Invited" ? app.createdAt : app.dateApplied,
  }));

  /**********/
  const [checkboxStates, setCheckboxStates] = useState({});

  const allChecked =
    Object.keys(checkboxStates).length > 0 &&
    Object.keys(checkboxStates).length === rowsWithNameAndDate?.length;
  Object.keys(checkboxStates)?.map((ele) => {
    return checkboxStates[ele]?.checked;
  });

  const selectAllHandler = (value) => {
    if (allChecked) {
      setCheckboxStates({});
    } else {
      setCheckboxStates(
        rowsWithNameAndDate?.reduce((acc, mentor) => {
          const isChecked = !mentor[mentor?.id]?.checked;

          acc[mentor.id] = { checked: isChecked, data: mentor };
          return acc;
        }, {})
      );
    }
  };

  const clearSelectedHandler = () => {
    setCheckboxStates({});
  };

  const handleCheckboxChange = (rowId, data) => {
    setCheckboxStates((prevState) => {
      const isChecked = !prevState[rowId]?.checked;

      const updatedState = {
        ...prevState,
        [rowId]: { checked: isChecked, data },
      };

      // Keep only entries where `checked` is true
      const filteredState = Object.fromEntries(
        Object.entries(updatedState).filter(
          ([_, value]) => value.checked === true
        )
      );

      return filteredState;
    });
  };

  const exportDataHandler = () => {
    const baseLabels = [
      "Full Name",
      "Role",
      "Status",
      //  "Date Applied",
      "Email",
    ];
    const baseDataKeys = [
      "fullName",
      "role",
      "status",
      //  "dateApplied",
      "email",
    ];

    const uniqueQuestionsMap = new Map(); // key: question text, value: qKey like q0, q1, etc.

    const tableData = Object.keys(checkboxStates)
      ?.map((id) => {
        const data = checkboxStates[id]?.data;
        if (!data) return null;

        const questionEntries =
          data?.questionsData?.map((question) => {
            const questionText = question?.questions?.question?.trim();
            if (!questionText) return null;

            // Assign a qKey if it's a new question
            if (!uniqueQuestionsMap.has(questionText)) {
              const qKey = `q${uniqueQuestionsMap.size}`;
              uniqueQuestionsMap.set(questionText, qKey);
            }

            // Clean the answer
            let answer = question?.answer;
            if (typeof answer === "string") {
              answer = answer.replace(/[{"}]/g, "").trim();
            }

            const qKey = uniqueQuestionsMap.get(questionText);
            return { [qKey]: answer };
          }) || [];

        const mergedQuestionAnswers = Object.assign({}, ...questionEntries);

        return {
          fullName:
            data.applicationStatus === "Pending"
              ? data?.firstName + " " + data?.lastName
              : data?.email,
          role: data?.role || data?.joinAs,
          status: data?.applicationStatus || data?.status,
          email: data?.email,
          // dateApplied: formatDateForMeetings(data.dateApplied),
          ...mergedQuestionAnswers,
        };
      })
      .filter(Boolean);

    // Finalize labels and dataKeys
    const questionLabels = Array.from(uniqueQuestionsMap.keys());
    const questionDataKeys = Array.from(uniqueQuestionsMap.values());

    const escapeCSVValue = (value) => {
      if (
        typeof value === "string" &&
        (value.includes(",") || value.includes("\n") || value.includes('"'))
      ) {
        return `"${value.replace(/"/g, '""')}"`; // Escape inner double quotes
      }
      return value;
    };

    const finalLabels = [...baseLabels, ...questionLabels].map(escapeCSVValue);

    ExportCSV({
      // labels: [...baseLabels, ...questionLabels],
      labels: finalLabels,
      dataKeys: [...baseDataKeys, ...questionDataKeys],
      tableData,
      fileName: "Export_Applicants",
    });
  };

  const printDataHandler = () => {
    const labels = ["Full Name", "Role", "Status", "Date Applied"];

    const dataKeys = ["fullName", "role", "status", "dateApplied"];

    const selectedData = Object.keys(checkboxStates)
      ?.map((id) => {
        const data = checkboxStates[id]?.data;

        if (!data) return null;

        // const queAnsData =
        //   data?.questionsData?.map((question, index) => {
        //     labels.push(question?.questions?.question);
        //     dataKeys.push(`q${index}`);

        //     // Clean the answer: remove braces and quotes
        //     let answer = question?.answer;

        //     if (typeof answer === "string") {
        //       answer = answer.replace(/[{"}]/g, "").trim();
        //     }

        //     return { [`q${index}`]: answer };
        //   }) || [];

        // const mergedQueAns = Object.assign({}, ...queAnsData);

        return {
          fullName:
            data.applicationStatus === "Pending"
              ? data?.firstName + " " + data?.lastName
              : data?.email,
          role: data?.role || data?.joinAs,
          status: data?.applicationStatus || data?.status,
          dateApplied: formatDateForMeetings(data.dateApplied),
          // ...mergedQueAns,
        };
      })
      .filter(Boolean);

    if (selectedData.length === 0) {
      alert("No data to print");
      return;
    }

    const tableHtml = `
      <table>
        <thead>
          <tr>
            ${labels.map((key) => `<th>${key}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${selectedData
            .map(
              (row) => `
            <tr>
              ${dataKeys.map((key) => `<td>${row[key] ?? ""}</td>`).join("")}
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
    `;

    const printWindow = window.open("", "", "width=900,height=700");

    const htmlContent = `
      <html>
        <head>
          <title>Print</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            table {
              border-collapse: collapse;
              width: 100%;
            }
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f0f0f0;
            }
          </style>
        </head>
        <body>
          ${tableHtml}
          <script>
            window.onload = function () {
              window.print();
              window.onafterprint = () => window.close();
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };
  /**********/

  return (
    <>
      {isOpenApplicationModal && applicationModal && (
        <ApplicationModal
          {...{
            applicationModal,
            setApplicationModal,
            setIsOpenApplicationModal,
          }}
        />
      )}
      <MentorsContainerOuter>
        <MentorsHead>
          <BackButton
            onClick={() => {
              if (setSwitchToParticipantOneOnOne) {
                setSwitchToParticipantOneOnOne("participants");
              }
              setSwitchToParticipants("participants");
            }}
          >
            <Icon type="back" />
            <ButtonText>Back</ButtonText>
          </BackButton>
        </MentorsHead>
        <MentorsBottom>
          {/* <MentorDescription>
            <MentorsHeading>Applicants</MentorsHeading>
            <MentorsInfo>{participantLength} Active applicants</MentorsInfo>
          </MentorDescription> */}
          <div
            style={{
              display: "block",
            }}
          >
            <ExportDeleteBtnContainer
              style={{
                display:
                  Object.keys(checkboxStates).length === 0 ? "none" : "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "4px",
                }}
              >
                <MeetingsInfo>
                  {Object.keys(checkboxStates).length + " Selected"}
                </MeetingsInfo>
                <button
                  onClick={clearSelectedHandler}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                >
                  {Object.keys(checkboxStates).length > 0 && (
                    <Icon type="cross" size="12" />
                  )}
                </button>
              </div>
              <BackButton
                style={{ padding: "6px" }}
                onClick={exportDataHandler}
              >
                <Icon type="export" />
                <ButtonText>Export</ButtonText>
              </BackButton>
              <BackButton style={{ padding: "6px" }} onClick={printDataHandler}>
                <Icon type="print" />
                <ButtonText>Print</ButtonText>
              </BackButton>
            </ExportDeleteBtnContainer>
          </div>

          <SearchBoxFilterContainer>
            <SearchParticipantsWrapper>
              <Icon type="search" />
              <TextInput
                placeholder="Search for Applications"
                value={searchParticipant}
                setValue={setSearchParticipant}
                isSearch={true}
              />
            </SearchParticipantsWrapper>

            <FilterOption onClick={() => setFilterOptions(!filterOptions)}>
              <Icon type="filter" />
              <FilterText>Filter</FilterText>
            </FilterOption>
            {filterOptions && (
              <FilterOptions>
                <FilterHeadText>Filter By</FilterHeadText>
                <FilterBy>
                  <FilterLabel>
                    <FilterLabelText>Status</FilterLabelText>
                    <FilterClear>Clear</FilterClear>
                  </FilterLabel>
                  <Select id="status" value={status} onChange={handleChange}>
                    <Option value="" disabled>
                      Choose Option
                    </Option>
                    <Option value="invited">Invited</Option>
                    <Option value="pending">Pending</Option>
                  </Select>
                </FilterBy>
                <FilterButtons>
                  <ResetButton onClick={resetFilters}>Reset All</ResetButton>
                  <ApplyButton onClick={applyFilters}>
                    {loading ? (
                      <Icon type={"loading"} size="16" color="#ffffff" />
                    ) : (
                      "Apply Filter"
                    )}
                  </ApplyButton>
                </FilterButtons>
              </FilterOptions>
            )}
          </SearchBoxFilterContainer>
        </MentorsBottom>

        <TableContainer>
          <Table
            loader={loading}
            {...{ pageSize, setPageSize, page, setPage }}
            meetingsDashboard={true}
            isApplicants={true}
            meetings={true}
            isActive={true}
            selectAllHandler={selectAllHandler}
            allChecked={allChecked}
            columns={[
              {
                key: "name",
                title: "Full Name",
                checkbox: true,
                sortable: true,
                sortValueFn: (row) => {
                  const isPending = row.applicationStatus === "Pending";
                  if (isPending) {
                    const fullName = `${row.firstName ?? ""} ${
                      row.lastName ?? ""
                    }`.trim();
                    return fullName.toLowerCase();
                  } else {
                    return (row.email ?? "").toLowerCase();
                  }
                },
                render: ({ row }) => {
                  return (
                    <NameContainer>
                      <Checkbox
                        value={!!checkboxStates[row.id]}
                        setValue={(event) => handleCheckboxChange(row?.id, row)}
                      />
                      {row.applicationStatus === "Pending" ? (
                        <AvatarInfo>
                          <Info nonWidth={true}>
                            <Avatar
                              leftSpace={1}
                              src={
                                row?.image
                                  ? row?.image
                                  : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                              }
                            />
                          </Info>
                          <p>{row.name}</p>
                        </AvatarInfo>
                      ) : (
                        <p>{row?.email}</p>
                      )}
                    </NameContainer>
                  );
                },
              },
              {
                key: "roles",
                title: "Roles",
                sortable: true,
                sortValueFn: (row) => row.joinAs ?? row.role ?? "",
                render: ({ row }) => (
                  <JoinAs>{row.joinAs ?? row.role ?? "-"}</JoinAs>
                ),
              },
              {
                key: "status",
                title: "Status",
                sortable: true,
                sortValueFn: (row) => row.applicationStatus ?? "",
                render: ({ row }) => {
                  const status = row?.applicationStatus;
                  return status === "Invited" ? (
                    <Invited>{status}</Invited>
                  ) : (
                    <Pending>{status}</Pending>
                  );
                },
              },
              {
                key: "dateApplied",
                title: "Date Applied",
                sortable: true,
                sortValueFn: (row) =>
                  row.dateApplied ? new Date(row.dateApplied).getTime() : null,
                render: ({ row }) => formatDateForMeetings(row.dateApplied),
              },
              {
                key: "Action",
                title: "Action",
                render: ({ row }) => {
                  return row.applicationStatus === "Invited" ? (
                    <Cancel
                      isCenter={true}
                      onClick={() => cancelInvite(row.id)}
                    >
                      Cancel
                    </Cancel>
                  ) : (
                    <ViewApplication
                      isCenter={true}
                      onClick={() => {
                        setApplicationModal(row);
                        setIsOpenApplicationModal(true);
                      }}
                    >
                      <Icon type={"view"} />
                      View Application
                    </ViewApplication>
                  );
                },
              },
            ]}
            rows={rowsWithNameAndDate}
          />

          {/* pagination */}
          <TablePagination>
            <div>
              <ResultsLabel>
                Results per page:
                <ResultsSelect
                  value={pageSize}
                  onChange={(e) => setPageSize(e.target.value)}
                >
                  {[5, 10, 15, 20].map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </ResultsSelect>
              </ResultsLabel>
            </div>
            <PaginationButtons>
              <PaginationSpan>
                <CurrentPage>{page}</CurrentPage> out of{" "}
                {Math.ceil(count / pageSize)}
              </PaginationSpan>
              <PreviousButton
                onClick={() => page !== 1 && setPage(page - 1)}
                disabled={page === 1}
              >
                <AngleSpan>{"<"}</AngleSpan> Previous
              </PreviousButton>

              <NextButton
                onClick={() =>
                  page !== Math.ceil(count / pageSize) && setPage(page + 1)
                }
                disabled={page === Math.ceil(count / pageSize)}
              >
                Next <AngleSpan next={true}>{">"}</AngleSpan>
              </NextButton>
            </PaginationButtons>
          </TablePagination>
        </TableContainer>
      </MentorsContainerOuter>
    </>
  );
};

export default Applicants;
